<div class="flex flex-col w-full gap-4 pb-8">
  <div class="px-1 sm:px-4 w-full 2xl:w-[95%] mx-auto">
    <div class="px-1 sm:px-2 flex flex-col gap-1 py-4">
      <div class="text-(--color-text-primary) font-semibold text-2xl">
        {{ 'tickets.create.title' | translate }}
      </div>
    </div>
  </div>

  <div class="px-1 sm:px-4 w-full 2xl:w-[95%] mx-auto">
    <div class="general-box">
      <div class="text-(--color-text-primary) font-semibold text-2xl">
        {{ 'tickets.create.sections.connectionPoints' | translate }}
      </div>

      <div class="grid gap-2 gap-y-6 grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 p-4">
        <app-input-general
          [label]="'tickets.create.fields.id'"
          [placeholder]="'tickets.create.fields.id'"
          [formControlGeneral]="formGroup.get('key')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.connectionPoint'"
          [placeholder]="'tickets.create.fields.connectionPoint'"
          [formControlGeneral]="formGroup.get('ubicacion')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.priority'"
          [placeholder]="'tickets.create.fields.priority'"
          [formControlGeneral]="formGroup.get('prioridad')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.address'"
          [placeholder]="'tickets.create.fields.address'"
          [formControlGeneral]="formGroup.get('domicilio')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.exteriorNumber'"
          [placeholder]="'tickets.create.fields.exteriorNumber'"
          [formControlGeneral]="formGroup.get('noExterior')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.interiorNumber'"
          [placeholder]="'tickets.create.fields.interiorNumber'"
          [formControlGeneral]="formGroup.get('noInterior')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.phone'"
          [placeholder]="'tickets.create.fields.phone'"
          [formControlGeneral]="formGroup.get('telefono')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.postalCode'"
          [placeholder]="'tickets.create.fields.postalCode'"
          [formControlGeneral]="formGroup.get('codigoPostal')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.neighborhood'"
          [placeholder]="'tickets.create.fields.neighborhood'"
          [formControlGeneral]="formGroup.get('colonia')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.city'"
          [placeholder]="'tickets.create.fields.city'"
          [formControlGeneral]="formGroup.get('poblacion')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.state'"
          [placeholder]="'tickets.create.fields.state'"
          [formControlGeneral]="formGroup.get('estado')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.zone'"
          [placeholder]="'tickets.create.fields.zone'"
          [formControlGeneral]="formGroup.get('zona')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.latitude'"
          [placeholder]="'tickets.create.fields.latitude'"
          [formControlGeneral]="formGroup.get('latitud')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.longitude'"
          [placeholder]="'tickets.create.fields.longitude'"
          [formControlGeneral]="formGroup.get('longitud')"
        ></app-input-general>
      </div>
    </div>
  </div>

  <div class="px-1 sm:px-4 w-full 2xl:w-[95%] mx-auto">
    <div class="general-box">
      <div class="text-(--color-text-primary) font-semibold text-2xl">
        {{ 'tickets.create.sections.contactPoint' | translate }}
      </div>

      <div class="grid gap-2 gap-y-6 grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 p-4">
        <app-input-general
          [label]="'tickets.create.fields.fullName'"
          [placeholder]="'tickets.create.fields.fullName'"
          [formControlGeneral]="formGroup.get('nombreContacto')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.contactPhone'"
          [placeholder]="'tickets.create.fields.contactPhone'"
          [mask]="'(000) 000-0000'"
          [formControlGeneral]="formGroup.get('telefonoContacto')"
        ></app-input-general>
        <app-input-general
          [label]="'tickets.create.fields.contactEmail'"
          [placeholder]="'tickets.create.fields.contactEmail'"
          [formControlGeneral]="formGroup.get('correoContacto')"
        ></app-input-general>
      </div>
    </div>
  </div>

  <div class="px-1 sm:px-4 w-full xl:w-[95%] mx-auto">
    <div class="general-box">
      <div class="text-(--color-text-primary) font-semibold text-2xl">
        {{ 'tickets.create.sections.workflow' | translate }}
      </div>

      <div class="grid gap-2 gap-y-6 grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 p-4">
        <app-input-general-radio-button
          [label]="'tickets.create.fields.workflowType'"
          [formControlGeneral]="formGroup.get('tipoFlujo')"
          [arrayData]="workFlowTypes"
          [InputSelectRadioButton]="{
            value: 'Id',
            description: '',
            nameCards: 'Description',
          }"
        ></app-input-general-radio-button>

        <app-input-general-select
          [label]="'tickets.create.fields.workflow'"
          [placeholder]="'tickets.create.fields.workflowPlaceholder'"
          [formControlGeneral]="formGroup.get('flujo')"
          [arrayData]="workFlowsAux"
          [inputSelect]="{
            value: 'Id',
            description: 'Description',
          }"
        ></app-input-general-select>
      </div>
    </div>
  </div>

  <div class="px-1 sm:px-4 w-full xl:w-[95%] mx-auto">
    <div class="general-box">
      <div class="text-(--color-text-primary) font-semibold text-2xl">
        {{ 'tickets.create.sections.additionalFields' | translate }}
      </div>

      <div class="p-4">
        <app-form-dinamic
          [formGeneral]="formGroup"
          [closingFields]="workFlowsSelect?.WorkFlowEditFields || []"
          [codeDependencies]="codeDependencies"
        ></app-form-dinamic>
      </div>
    </div>
  </div>

  <div class="w-full m-auto">
    <div class="w-50 m-auto justify-center flex">
      <button (click)="ticketCreate()" class="button-general-border w-full" matButton>
        <div class="flex justify-center items-center gap-4">
          <div>{{ 'common.actions.accept' | translate }}</div>
        </div>
      </button>
    </div>
  </div>
</div>

<app-load-general [load]="load"></app-load-general>
